module.exports = __webpack_public_path__ + "static/media/jeris-old.bbf0c139.png";